export const getPaginationUrl=(paginationData)=>{
    return `?page=${paginationData?.pageNum}&limit=${paginationData?.gridSize}&search=${encodeURIComponent(paginationData?.search)}`
    }